<template>
  <div class="mj_page flex jb">
    <div class="left_area flex jb">
      <div class="logo_area flex jc ac">
        <!--        <img alt="" src="./img/dallE3/openai-logo.png"/>-->
        <img alt="" src="./img/dallE3/dall_log1.png"/>
        <p class="title">DALL-E3<span>AI</span></p>
        <p class="desc">拥有GPT4.0一样强大的理解能力，您无需遵循严格的指令格式，更能理解您想要什么，并准确地画出来。
        </p>
      </div>
      <lingganTool
      ref="lingganref"
      :calc_width="24"
      :MD5_KEY="'cd8e59bc2f6064050f6e201673b68cfc'"
      :show_list="['desc','img_urls','set_detail']"
      @createSame="createSame" 
      @use_only="use_only"
      ></lingganTool>
      <div class="model_list">
        <div class="title flex ac"><img src="./img/icon_img3.png"/> 模型广场</div>
        <div class="item flex ac"
             v-for="(item,index) in model_list"
             :class="img_model==item.name?'active':''"
             @click="choose_model(item)"
             :key="index">
          <span>#</span>
          <div class="desc">
            <strong class="flex ac">{{ item.title }}</strong>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
      <div class="person flex jb ac">
        <template v-if="!isLogin">
          <div class="flex ac"
               @click="handle_show_person_hover">
            <img src="./img/default-avatar.png"
                 class="avatar"/>
            <div class="info">
              <p class="name flex ac">未登录</p>
              <p class="id">访客</p>
            </div>
          </div>
          <img src="./img/icon_img7.png"
               @click="handle_show_person_hover"
               class="icon_person"/>
        </template>
        <template v-else>
          <div class="flex ac"
               @click="handle_show_person_hover">
            <img src="./img/default-avatar.png"
                 class="avatar"/>
            <div class="info">
              <p class="name flex ac">{{ userInfo.nickname }}
                <img src="./img/vip.png"
                     alt=" "
                     v-if="userInfo.is_vip==0"
                     style="filter: grayscale(100%);"/>
                <img v-else src="./img/vip.png" class="avatar"/>
              </p>
              <p class="id">ID:{{ userInfo.uid }}</p>
            </div>
          </div>
          <img src="./img/icon_img7.png"
               @click="handle_show_person_hover"
               class="icon_person"/>
        </template>
        <div class="person_hover"
             ref="person_hover"
             v-if="show_person_hover&&!isLogin">
          <div class="close_btn2" @click="show_person_hover=false"
               style="margin-bottom: 10px;text-align: right;cursor: pointer;">
            <!--            关闭2-->
            <div>
              <i class="el-icon-circle-close"></i>
            </div>
          </div>
          <div class="user_avatar flex jb">
            <img src="./img/default-avatar.png" class="pic"/>
          </div>
          <div class="item user">
            <p class="name flex ac">未登录</p>
            <p class="id">访客</p>
          </div>
          <div class="item flex jb ac logout"
               @click="handleLogin">
            <p class="logout_desc flex ac">
              <img src="./img/switch-user.png"/> 立即登录</p>
            <img src="./img/icon_img11.png" class="icon_right"/>
          </div>
        </div>
        <div class="person_hover"
             ref="person_hover"
             v-if="show_person_hover&&isLogin">
          <div class="close_btn2" @click="show_person_hover=false"
               style="margin-bottom: 10px;text-align: right;cursor: pointer;">
            <!--            关闭2-->
            <div>
              <i class="el-icon-circle-close"></i>
            </div>
          </div>
          <div class="user_avatar flex jb">
            <img src="./img/default-avatar.png" class="pic"/>
            <span class="edit_area"
                  @click="show_userinfo">
              <img src="./img/icon_img10.png" class="icon_edit"/></span>
          </div>
          <div class="item user">
            <p class="name flex ac">{{ userInfo.nickname }}
              <img src="./img/vip.png" alt=" " v-if="userInfo.is_vip==0" style="filter: grayscale(100%);"/>
              <img v-else src="./img/vip.png" class="avatar"/>
            </p>
            <p class="id">ID:{{ userInfo.uid }}</p>
          </div>
          <div class="item open">
            <p class="fz13">MJ绘画 会员身份</p>
            <p class="open_desc">{{ userInfo.vip_name }}|{{ userInfo.vip_end_date }}</p>
          </div>
          <div class="item point">
            <p class="fz13">MJ绘画 积分</p>
            <p class="flex ac">
              <img src="./img/icon_img8.png" alt=" "/> 积分：{{ userInfo.score_balance }}</p>
          </div>
          <div class="item flex jb ac logout"
               @click="handleLogout">
            <p class="logout_desc flex ac">
              <img src="./img/icon_img9.png"/>
              退出登录
            </p>
            <img src="./img/icon_img11.png" class="icon_right"/>
          </div>
        </div>
      </div>
    </div>
    <div class="draw_area">
      <div class="draw_area_tips">
        <span class="one">#</span><span class="two">创作中心</span><span class="three">请遵守中华人民共和国网络安全法， 严禁生成涉及政治人物，色情、恐怖等不良内容， 如有违规封号处理</span>
      </div>
      <!--样例数据开始-->
      <div class="draw_scroll"
           ref="scrollWrap" @scroll="testScroll">
        <div class="draw_list"
             v-if="!isLogin||draw_list.length==0">
          <div class="draw_list_item flex jb"
               v-for="(item,index) in sampleSysList"
               :key="index">
            <img alt="" src="./img/dallE3/dall_log1.png"
                 class="avatar"/>
            <div class="text">
              <div class="title flex jb ac">
                <p class="info flex ac"><span class="name">DALL-E3</span><span class="tag">AI</span><span class="time">{{
                    item.add_time
                  }}</span>
                </p>
                <div class="flex ac">
                  <p class="delete flex ac"
                     @click="sampleDeleteDraw(item, index)"><img src="./img/delete.svg"/><span>删除</span></p>
                </div>
              </div>
              <div class="desc">
                <p class="zh">{{ item.prompt }}</p>
                <p class="en">{{ item.prompt_en }}</p>
              </div>
              <div>
                <div class="big_img">
                  <div class="msg_img_wrap">
                    <el-image style="display:block;max-width: 400px;"
                              @click.prevent="clickImage(item.id,'sample')"
                              :src="item.oss_small_img"
                              :preview-src-list="[item.raw_img_url ]">
                    </el-image>
                    <div @click.stop="ImageJump(item.raw_img_url,item.s_w,item.s_h)" class="look_img">查看原图</div>
                    <Senior_Editor
                        :ListItem="item"
                        :site="'right'"
                        :drawtype="'dall'"
                        :btntype="'btn_dalle3_create'"
                        @success="achievetask">
                    </Senior_Editor>
                    <videoTipBox v-if="videoTipBoxShow == 'true'"></videoTipBox>
                  </div>
                  <div class="tozan">
                    <div class="zanOne" @click="tozanFn(item,index)" v-show="!item.is_vote">
                      <img src="./img/zan1.png" class="zanImg"/> 赞一下
                    </div>
                    <div class="zanDetail" v-show="item.is_vote">
                      <div class="zanOne zanTwo">
                        <img src="./img/zan2.png" class="zanImg"/> 已赞过
                      </div>
                    </div>
                    <div class="zanTex">
                      此作品已获得{{ item.votes }}个赞
                    </div>
                  </div>
                </div>
                <mgcPop :btntype="'btn_dalle3_create'" :item="item" :is-first="index" :is-samp="true" :is-d3="true"></mgcPop>
              </div>
            </div>
          </div>
        </div>
        <!--样例数据结束-->
        <!-- </div>
    <div class="draw_scroll"> -->
        <!--      登录过后  -->
        <div class="draw_list"
             v-infinite-scroll="loadMore"
             :infinite-scroll-disabled="noMore || loading">
          <div class="draw_list_item flex jb"
               v-for="(item,index) in draw_list"
               :key="index">
            <img src="./img/dallE3/dall_log1.png"
                 class="avatar"/>
            <div class="text">
              <div class="title flex jb ac">
                <p class="info flex ac">
                  <span class="name">DALL-E3</span>
                  <span class="tag" v-if="item.img_type=='img_edit'"> 高级编辑 - {{ item.model_version }}</span>
                  <span class="tag" v-else>AI-Bot</span>
                  <span class="mgTitp" v-if="item.img_type=='img_video'">魔法</span>
                  <span class="time">{{ item.add_time }}</span></p>
                <div class="flex ac">
                  <p class="delete flex ac"
                     @click="share_draw_item(item, index)"><img class="share"
                                                                src="./img/icon_img48.png"/><span>分享</span></p>
                  <template
                      v-if="(item.img_type=='img_c'||item.img_type=='img_v'||item.img_type.indexOf('zoom')>0||item.img_type.indexOf('_pan_')>0||item.img_type.indexOf('_variation')>0) && item.status==2">
                    <p class="delete flex ac"
                       v-if="item.is_public==0"
                       @click="pulic_draw_item(item, index)"><img src="./img/prasie.png"/><span>推荐到广场</span></p>
                    <p class="delete flex ac"
                       v-else
                       style="color: #f0b132;"
                       @click="pulic_draw_item(item, index)"><img src="./img/prasie-fill.png"/><span>已推荐到广场</span>
                    </p>
                  </template>
                  <!-- <p class="delete flex ac"
                     v-if="item.cate_id==0"
                     @click="fave_draw_item(item,index)"><img src="./img/favorites.svg"/><span>采集</span></p> -->
                  <p class="delete flex ac" v-if="item.img_type=='img_video'" @click="down(item)">
                    <i class="el-icon-download" style="font-size: 16px;padding-top: 4px"></i><span>下载</span></p>
                  <p class="delete flex ac"
                     @click="delete_draw_list(item.draw_id, index)"><img src="./img/delete.svg"/><span>删除</span></p>
                </div>
              </div>
              <div class="desc">
                <p class="zh">{{ item.prompt }}</p>
                <p class="en" v-if="item.prompt_en">{{ item.prompt_en }}</p>
              </div>
              <div class="create_error" v-loading="item.regenerateload"
                   v-if="(item.status == 3)&&(item.retry_num<3 && item.is_retry==0)">
                <!-- 绘画 失败 -->
                <img class="error_icon" src="./img/image_error.png" alt="">
                <div class="error_text">很遗憾，绘画失败 !</div>
                <div class="error_text2" @click="regenerate(item,index)">点此重新生成</div>
                <div class="error_text3">（成功率在90%以上）</div>
                <div class="error_text4" v-if="item.show_error">
                  失败原因： <span style="color:red;">{{ item.show_error }}</span>
                </div>
                <div class="error_text4" v-else>涉政、涉黄等请勿提交，会封号其他问题，请联系<a
                    @click="utils.openKefu()"
                    target="_blank">在线客服</a></div>
              </div>
              <div class="create_error create_error_old"
                   v-else-if="(item.status == 3)&&(item.retry_num>=3 || item.is_retry!=0)">
                <!-- 绘画 失败 -->
                <img class="error_icon" src="./img/image_error.png" alt="">
                <div class="error_text">很遗憾，绘画失败 !</div>
                <div class="error_btn" @click="showDefeatPopup">查看失败原因</div>
                <!-- <div class="error_text2" @click="regenerate(item)">点此重新生成</div>
                <div class="error_text3">（成功率在90%以上）</div> -->
                <div class="error_text4" v-if="item.show_error">
                  失败原因： <span style="color:red;">{{ item.show_error }}</span>
                </div>
                <div class="error_text4" v-else>涉政、涉黄等请勿提交，会封号其他问题，请联系<a
                    @click="utils.openKefu()"
                    target="_blank">在线客服</a></div>
                <!--                <div class="error_btn" @click="showDefeatPopup">查看失败原因</div>-->
              </div>


              <template v-else-if="item.status < 2">
                <div class="detail_loading msg-item-content">
                  <circleloading></circleloading>
                  <div class="loading_text"
                       v-if="item.progress <= 0">DALL-E3 正在全力出图中，请稍等...
                  </div>
                </div>
                <div class="creating_progress"
                     v-if="item.progress > 0">
                  <div class="progress_bar">
                    <div class="progress_line"
                         :style="{'width':item.progress+'%'}"></div>
                  </div>
                  <div class="progress_percent">{{ item.progress }}%</div>
                </div>
              </template>
              <div v-else>
                <div class="big_img"
                     v-if="item.img_url">
                  <div class="msg_img_wrap mg_video_box" v-if="item.img_type=='img_video'">
                    <div class="mg_video_item">
                      <video class="videoBox" controlslist="nodownload" :poster="item.raw_img_url" controls>
                        <source :src="item.img_url" type="video/mp4">
                      </video>
                      <!-- <button id="playButton" class="play-btn">▶</button> -->
                    </div>
                  </div>
                  <div class="msg_img_wrap" v-if="item.img_type=='img_edit'">
                    <!-- 高级编辑 -->
                    <div class="SeniorEditor">
                      <div class="SeniorBox1">
                        <el-image style="display:block;max-width: 400px;"
                                  @click.prevent="clickImage(item.draw_id,'left')"
                                  :src="item.iw_small_url "
                                  :preview-src-list="[item.iw_url ]"
                        >
                        </el-image>
                        <div class="artwork">原图</div>
                        <!-- 高级编辑 -->
                        <Senior_Editor
                            :ListItem="item"
                            :site="'left'"
                            :drawtype="'dall'"
                            :btntype="'btn_dalle3_create'"
                            @success="achievetask">
                        </Senior_Editor>
                      </div>
                      <div class="SeniorBox2">
                        <el-image style="display:block;max-width: 400px;"
                                  @click.prevent="clickImage(item.draw_id,'right')"
                                  :src="item.img_url "
                                  :preview-src-list="[item.raw_img_url ]"
                        >
                        </el-image>
                        <div class="outcome">输出</div>
                        <!-- 高级编辑 -->
                        <Senior_Editor
                            :ListItem="item"
                            :site="'right'"
                            :drawtype="'dall'"
                            :btntype="'btn_dalle3_create'"
                            @success="achievetask">
                        </Senior_Editor>
                      </div>
                    </div>
                  </div>
                  <div class="msg_img_wrap" v-if="item.img_type!='img_edit'&&item.img_type!='img_video'">
                    <el-image style="display:block;max-width: 400px;"
                              @click.prevent="clickImage(item.draw_id)"
                              :src="item.img_url"
                              :preview-src-list="[item.raw_img_url ]">
                    </el-image>
                    <div @click.stop="ImageJump(item.raw_img_url,item.s_w,item.s_h)" class="look_img">查看原图</div>
                    <Senior_Editor
                        :ListItem="item"
                        :site="'right'"
                        :drawtype="'dall'"
                        :btntype="'btn_dalle3_create'"
                        @success="achievetask">
                    </Senior_Editor>
                    <videoTipBox v-if="videoTipBoxShow == 'true'"></videoTipBox>
                  </div>
                </div>
                <div class="creating_progress"
                     v-if="item.progress > 0 && item.status < 2">
                  <div class="progress_bar">
                    <div class="progress_line"
                         :style="{'width':item.progress+'%'}"></div>
                  </div>
                  <div class="progress_percent">{{ item.progress }}%</div>
                </div>
              </div>
              <mgcPop :btntype="'btn_dalle3_create'" :item="item" :is-first="index" @magData="mgcPFn" :is-d3="true"
                      v-if="item.img_type!='img_video'&&item.status==2&& item.img_type != 'img_edit'"></mgcPop>
            </div>
          </div>
        </div>
      </div>
      <div class="btm_area">
        <div class="btm_area_con">
          <!-- 点这里，开始AI绘画提示 -->
          <img src="./img/click.png"
               v-if="!showDrawTips"
               class="begin_draw_tips"/>
          <!--          <div class="text_area flex jb ac">-->
          <div class="text_area">
            <div class="text_1area" style="width: 100%">
               <textarea class="textarea"
                         v-model="inputVal"
                         placeholder="在此描述画面的关键词，注意不要在此填入萝莉、性感、血腥等敏感词内容，100%不会出图~">
               </textarea>
              <div class="submit flex ac" v-loading="sending" @click.stop.prevent="sendMsg">
                <span>提交</span>
                <img src="./img/icon_img36.png" alt=" "/>
              </div>

            </div>
            <div class="query_area">
              <!--                                <div class="query_area_item" @click="showDefeatPopup(2)">-->
              <!--                                  <i class="el-icon-edit"></i> AI咒语-->
              <!--                                </div>-->
              <div class="query_area_btn flex  ac"
                   @click="handle_advanced_options">
                <i class="el-icon-s-tools"></i>
                设置
              </div>
              <div class="automatic" @click="showTishici">
                <!-- <el-switch
                    style="zoom: 0.7"
                    @change="getPromptData4()"
                    v-model="auto_spell"
                    active-color="#5865f2"
                    inactive-color="#5a5c61"
                    active-value="1"
                    inactive-value="0">
                </el-switch> -->
                <div>
                  <img src="@/components/images/lingganImg/ai_tishi.png" class="ai_tishi_img" alt="">
                  Ai优化提示词（免费）
                </div>
              </div>
            </div>
            <!--            <div class="submit flex ac" v-loading="sending" @click.stop.prevent="sendMsg">-->
            <!--              <span>提交</span>-->
            <!--              <img src="./img/icon_img36.png" alt=" "/>-->
            <!--            </div>-->
          </div>

          <!-- 高级选项参数 -->
          <AdvancedOptions ref="AdvancedOptions"
                           v-if="show_advanced_options"
                           @close="close_advanced_options"></AdvancedOptions>
        </div>
        <div class="screen">
          内容由 Ai 生成，请仔细甄别
        </div>
      </div>
    </div>
    <popup ref="defeatPopup"
           type="center"
           @close="defeatPopClose(1)">
      <div class="defeat_popup">
        <div class="popup_title">失败原因如下</div>
        <div class="popup_content">
          <div class="content_item">
            <div class="item_question">问：为什么MJ绘画出图会比较慢？</div>
            <div class="item_answer">
              答：因为MJ绘画与其他绘画软件不同，一次性生成四张高清图片，通常仅需约5分钟完成，算下来速度相当快！
            </div>
          </div>
          <div class="content_item">
            <div class="item_question">问：为什么绘画会提示失败？</div>
            <div class="item_answer">
              答：因为MJ绘画全部为Ai原创，可能会出现违规低俗内容，这些图片会被系统自动过滤删除，与您无关！
            </div>
          </div>
        </div>
        <button class="close_btn"
                @click="defeatPopClose(1)">好的，我知道了
        </button>
      </div>
    </popup>
    <!--    ai咒语扩展-->
    <popup ref="interpose"
           type="center"
           :coverClose="false">
      <div class="interpose">
        <div class="top">
          <div>
            AI咒语扩展
          </div>
          <div class="close" @click="defeatPopClose(2)">
            <div>

            </div>
          </div>
        </div>
        <div class="body">
          <textarea class="text" v-model="interposeText" maxlength="100"
                    placeholder="请输入你的描述，让AI帮你扩词。如：末日逃生"> </textarea>
          <div class="text_num">
            <span>{{ interposeText.length }} / 100</span>
          </div>
        </div>
        <div class="bottom">
          生成描述
        </div>

      </div>
    </popup>
    <!--    ai咒语扩展-->
    <!-- 反馈弹窗 -->
    <FeedBack v-if="current_draw&&show_feedback_popup"
              :draw_item="current_draw"
              @close="show_feedback_popup=false"
              ref="feedback"></FeedBack>
    <!-- 推荐到广场 -->
    <Recommend v-if="current_draw&&show_recommend_popup"
               :draw_item="current_draw"
               @close="recommendCallBack"
               ref="recommend"></Recommend>
    <!-- 分享 -->
    <ShareDraw v-if="current_draw&&show_sharedraw_popup"
               :draw_item="current_draw"
               @close="show_sharedraw_popup=false"
               ref="ShareDraw"></ShareDraw>
    <!--采集-->
    <drawCateEdit ref="drawCateEdit"
                  @close="caiJiOk"></drawCateEdit>
    <!-- C1 查看 -->
    <canvas ref="localCanvas"
            style="display: none;"
            useCORS="true"
            allowTaint="true"></canvas>
    <el-image style="display: none;" ref="previewImg" :src="view_img_url" :preview-src-list="[view_img_url]"></el-image>

    <!-- 提示词弹窗 -->
    <TipsWords v-if="is_show_tips_com"></TipsWords>
    <loginPanel ref="loginPanel"></loginPanel>
    <!-- 实名认证 -->
    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>

    <!-- ai提示词 -->
    <AIpromptWords
        :fix_size="true"
        :typedata="'DALL-E3'"
        :inpdata="inputVal"
        @getPromptData1="getPromptData2"
        ref="promptBox"/>
  </div>
</template>

<script>
import popup from "COMPONENTS/Popup.vue"
import circleloading from "COMPONENTS/CircleLoading.vue"
import FeedBack from '@/components/FeedBack.vue'
import Recommend from '@/components/Recommend.vue'
import ShareDraw from '@/components/ShareDraw.vue'
import drawCateEdit from '@/components/DrawCateEdit'
import TipsWords from '@/components/TipsWords'
import AdvancedOptions from '@/components/AdvancedOptionsCop'
import loginPanel from "COMPONENTS/LoginPanel.vue"
import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu"
import mgcPop from "../components/mgcPop.vue"
import AIpromptWords from "COMPONENTS/AIpromptWords.vue";
import utils from '../utils/index.js'
import Senior_Editor from "COMPONENTS/Senior_Editor.vue";
import videoTipBox from "COMPONENTS/videoTipBox.vue";
import lingganTool from "COMPONENTS/lingganTool.vue";

export default {
  components: {
    videoTipBox,
    Senior_Editor,
    AIpromptWords,
    mgcPop,
    loginPanel,
    AdvancedOptions,
    popup,
    circleloading,
    FeedBack, Recommend, ShareDraw, drawCateEdit, TipsWords, faceVerifyPopup, lingganTool,
  },
  data() {
    return {
      // kefu_url:SITE_BTN_CONFIG.kefu_url.btn_value,
      //显示个人中心
      show_person_hover: false,
      //显示用户反馈
      show_feedback_popup: false,
      //显示推荐到广场
      show_recommend_popup: false,
      //显示分享弹窗
      show_sharedraw_popup: false,
      //模型列表
      model_list: [{
        name: "NJ6.0",
        title: '动漫模型',
        desc: '常规 DALL-E·3 动漫模型',
      }, {
        name: "MJ6.0",
        title: '真实模型',
        desc: '常规 DALL-E·3 真实模型',
      }],

      //绘图模式列表
      fastModeList: [{
        is_fast: -1,
        name: '绘图模式',
        src: require('./img/icon_img38.png'),
        is_disabled: true,
        tooltip: '普通模式：高峰期预计需要10分钟出图（非会员4积分，普通会员1积分，高级/超级会员免积分）<br/>快速模式：会员专享模式，平均1-2分钟出图（每张消耗4积分）'
      }, {
        is_fast: 1,
        name: '快速模式',
        src: require('./img/icon_img37.png'),
        is_disabled: false,
      }, {
        is_fast: 0,
        name: '普通模式',
        src: require('./img/icon_img37.png'),
        is_disabled: false,
      }],
      //当前选中模型
      img_model: 'NJ6.0',
      //选中的mode
      fastIndex: 1,
      is_fast: 1,
      //展示隐藏search_tips
      search_tips: false,
      inputVal: '',//输入框数据
      draw_list: [],
      show_advanced_options: false,
      sending: false, // 提交绘画状态
      posting: false,
      settingData: {
        artistry: 0,
        model: 1,
        outrageous: 0,
        ratio: "", // 生成尺寸
      },
      upload_img_url: "",
      img_iw: 0, //设定文本提示对图像的影响权重，默认为--iw 0.25
      powerList: {
        0.5: '低',
        1: '默认',
        1.5: '中',
        2: '高'
      },
      upoadLoading: false,
      view_img_url: "",
      split_img_url: "",
      advanceForm: null, // 高级配置参数
      current_draw: null,//当前选中的记录
      Original: '',
      noMore: false, // 是否还有数据
      loading: false, // 正在请求数据
      max_mj_id: 0, // 最小的ID
      checkIds: [], // 生成中的需要检测的ID
      timer: null,
      sampleSysList: [], // 系统样例
      sampleUserList: [], // 用户样例
      sampleSelectList: [], // 选择样例
      sampleTimer: null,
      showDrawTips: localStorage.getItem("showDrawTips") || 0,
      interposeText: '',
      page: 1,
      pageType: false,
      currentTimer: new Date(),

      auto_spell: '1',
      perIncan: false, // ai提示词是否返回
      md5_key:false,
      md5_id:false,
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    is_show_tips_com() {
      return this.$store.state.shou_tips_com
    },
    videoTipBoxShow() {
      return this.$store.state.videoTipBoxShow
    },
  },
  created() {
    this.sampleUserList = JSON.parse(localStorage.getItem("sampleUserListDall") || "[]")
    this.fetchDataList()
    this.fettchSampleList()
  },
  methods: {
    showTishici(){
      if(this.$refs.lingganref){
        this.$refs.lingganref.visible = false
        this.$refs.lingganref.show_detail_popup = false

      }
      if(document.querySelector('.autoMatic_box')){
        this.$refs.promptBox.show(false)
      }else{
        if (!this.isLogin) {
          this.$message.warning('请先登录！')
          return
        }
        if(!this.inputVal.trim().length){
          this.$message.warning('请输入创意描述！')
          return 
        }
        this.$refs.promptBox.show(true)
      }
    },
    //单一功能赋值
    use_only(data){
      if(data.type=='desc'){
        this.inputVal = data.data.desc
      }else if(data.type=='set_detail'){
        if(data.data.option_json.img_model){
          this.img_model = data.data.option_json.img_model
        }
        this.advanceForm = data.data.option_json.parameters
      }

    },
    // 创建同款
    createSame(data){
      this.inputVal = data.desc
      if(data.option_json.img_model){
        this.img_model = data.option_json.img_model
      }
      this.advanceForm = data.option_json.parameters
      this.md5_key = data.md5_key
      this.md5_id = data.id
    },
    testScroll() {
      // console.log('滚动');
      utils.setScrollDoc(null, 420, -50)

    },
    tozanFn(data, ind) {
      console.log(data)
      this.$http.put(`/front/aimj/draw/sample/`, {id: data.id}).then(res => {
        if (res.status == 200) {
          data.votes++
          data.is_vote = 1
          const clickedItem = this.sampleSysList[ind];
          this.sampleSysList.splice(ind, 1); // 删除原位置的元素
          this.sampleSysList.unshift(clickedItem); // 插入到数组开头
        }
      }).catch((err) => {
        console.log('走错误');
        if (!this.isLogin) {
          // this.imgDialogVisible = false
          this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
            confirmButtonText: '立即登录',
            cancelButtonText: '关闭',
            type: 'warning'
          }).then(() => {
            this.$store.commit('setShowLogin', true)
          }).catch(() => {
          });
          return false;
        } else {

        }
      })
    },
    mgcPFn(data) {
      this.submitQuestion(data)
    },
    fettchSampleList() {

      // 获取样例数据
      this.$http.get('/front/aimj/draw/sample/', {
        params: {
          draw_soft: 'dall',
          page: this.page,
          size: 10,
        }
      }).then((res) => {
        console.log('j/draw/sample/\'', res.data)
        this.sampleSysList = this.sampleSysList.concat(res.data)

      })
    },
    sampleDrawImg() {
      // 样例图片 U V 处理
      if (this.isLogin) {
        this.$confirm('当前任务为演示数据，暂不支持该操作，请先执行绘画任务', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '关闭',
          type: 'warning'
        }).then(() => {
        }).catch(() => {
        });
      } else {
        this.checkLogin()
      }
    },
    sampleDeleteDraw(item, index) {
      // 样例图片 删除
      if (!this.checkLogin()) {
        return
      }
      this.$confirm('当前任务为演示数据，暂不支持该操作', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '关闭',
        type: 'warning'
      }).then(() => {
      }).catch(() => {
      })
      // this.$confirm('确定删除该创作记录吗，删除后不可恢复？', '提示', {
      //   type: 'warning'
      // }).then(() => {
      //   this.sampleSysList.splice(index, 1)
      //   let j = -1
      //   for (let i = 0; i < this.sampleUserList.length; i++) {
      //     if (this.sampleUserList[i].draw_id == item.draw_id) {
      //       j = i
      //     }
      //   }
      //   if (j > -1) {
      //     this.sampleUserList.splice(j, 1)
      //     localStorage.setItem("sampleUserListDall", JSON.stringify(this.sampleUserList))
      //   }
      // })
    },
    //选择提示词
    choose_tips_item(item) {
      // 样例 选中
      if (!this.checkLogin()) {
        return
      }
      let _item = {...item}
      _item.progress = 0
      // this.sampleSysList.unshift(_item)
      this.sampleSysList = [_item].concat(this.sampleSysList);
      // this.sampleUserList.unshift(item)
      this.sampleUserList = [item].concat(this.sampleUserList);
      localStorage.setItem("sampleUserListDall", JSON.stringify(this.sampleUserList), this.sampleTimer)

      this.scrollToTop()
      if (this.sampleTimer !== null) {
        return
      }
      this.sampleTimer = setInterval(() => {
        let createNum = 0; // 需要生成个数
        this.sampleSysList.forEach(e => {
          if (e.progress < 100) {
            createNum += 1
            let num = parseInt(Math.random() * 10);
            if (e.progress + num > 100) {
              e.progress = 100
              this.scrollToTop()
            } else {
              e.progress += num
            }
          }
        })
        if (createNum == 0) {
          clearInterval(this.sampleTimer)
          this.sampleTimer = null
          this.scrollToTop()
        }
      }, 500)
    },
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)
          this.$store.commit('setShowLogin', true)
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }
    },
    handleLogin() {
      // 登录
      if (!this.isLogin) {
        this.$store.commit('setShowLogin', true)
      }
    },
    handleLogout() {
      // 退出
      this.$confirm('确定要退出当前账号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.clear();
        this.$store.commit('setUserInfo', null)
        this.$store.commit('setIsLogin', false)
        // 推出跳转大厅
        this.$router.push('/square')
      }).catch(() => {
      });
    },

    handle_show_person_hover() {
      this.show_person_hover = !this.show_person_hover
    },
    //打开修改个人资料弹窗
    show_userinfo() {
      this.$store.commit('setShowUserInfo', true)
    },
    choose_model(item) {
      //选择模型
      this.img_model = item.name
    },
    //选择模式
    chooseFastMode(index) {
      this.fastIndex = index
      this.is_fast = this.fastModeList[index].is_fast
    },
    //关闭search_tips
    close_search_tips() {
      this.search_tips = false
    },
    //输入框获取焦点
    textarea_focus() {
      localStorage.setItem("showDrawTips", 1)
      this.showDrawTips = 1
      if (!this.isLogin || this.userInfo.is_vip < 1) {
        setTimeout(() => {
          this.search_tips = true
        }, 100)
      }
    },
    //输入框失去焦点
    textarea_blur() {
      setTimeout(() => {
        this.search_tips = false
      }, 100)
    },

    //点击弹出高级参数选项
    handle_advanced_options() {
      this.show_advanced_options = true
      // this.$nextTick(()=>{
      //     this.$refs.advancedOptions.initData()
      // })
    },
    //点击关闭高级参数选项
    close_advanced_options(data) {
      console.log('高级参数');
      console.log(data);
      
      this.advanceForm = data
      this.show_advanced_options = false
    },
    loadMore() {
      // 加载更多数据
      this.noMore = true
      this.loading = true
      if (this.isLogin) {
        // 登录请求样例
        this.fetchDataList()
      } else {
        // 未登录请求样例
        if (this.pageType) {
          // this.pageType = false
          if (this.page >= 3) {
            this.$message.warning('样例已全部加载')
            return
          }
          this.page = this.page + 1
          this.fettchSampleList()
        } else {
        }

      }
    },
    fetchDataList() {
      // 对话内容
      this.loading = true
      this.$http.get('/front/aidl/user/draw/', {
        params: {
          max_mj_id: this.max_mj_id,
          softs: 'dall',
        },
      }).then((res) => {

        if (res.status == 200) {
          if (res.data.item_list.length > 0) {
            res.data.item_list.forEach(item => {
              if (!item.regenerateload) {
                item.regenerateload = false
              }
            })
            if (this.max_mj_id == 0) {
              res.data.item_list.forEach(e => {

                if (e.status <= 1 || (e.status == 2 && e.local_img_url == "")) {
                  this.checkIds.push(e.draw_id)
                }
              })
              this.fetchMsg()
            }
            this.max_mj_id = res.data.item_list[res.data.item_list.length - 1].draw_id
            this.draw_list = this.draw_list.concat(res.data.item_list)
            // shibai
            // this.draw_list[0].status = 3
            // this.draw_list[0].status = 3
            // this.draw_list[0].show_error = 1
          } else {
            this.noMore = true
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getProfile() {
      this.$http.get(`/front/user/profile/`).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
        }
      }).finally(() => {
      })
    },
    //发送消息
    sendMsg() {
      this.show_advanced_options = false
      if (this.$refs.advancedOptions != undefined) {
        //
        this.$refs.advancedOptions.initData()
        this.advanceForm = this.$refs.advancedOptions.form
      }
      if (!this.checkLogin()) return

      if(SITE_BTN_CONFIG.btn_dalle3_create.btn_state==0){
        if(this.userInfo.is_vip==0){
          utils.createErrTip('no_open_vip')
        }else{
          if(this.userInfo.is_vip_end==1){
            utils.createErrTip('vip_expire')
          }else{
            this.$store.commit('setTechnical_Show',true)
          }
        }
        return;
      }

      if (this.userInfo.is_vip == 0 || this.userInfo.is_vip_end != 0) {
        this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
          confirmButtonText: '开通会员',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$router.push('/member')
          this.$store.commit('setisPayPopShow', true)
        }).catch(() => {

        });
        return
      }
      this.inputVal = this.inputVal.trim();
      if (!this.inputVal) {
        this.$message.warning('请输入文字信息')
        return
      }
      // if (this.auto_spell > 0) {
      //   if (this.perIncan == false) {
      //     this.$refs.promptBox.show(true)
      //     return;
      //   }
      // }
      // if (this.userInfo.score_balance < 2) {
      //   this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
      //     confirmButtonText: '升级套餐',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     this.$router.push('/member')
      //   }).catch(() => {
      //
      //   });
      //   return;
      // }
      if (this.sending) {
        this.$message.warning('请等待上次绘图完成')
        return
      }
      let parameters = {
        iw: 0.25,
        aspect: "16:9",// 大小比例
        // tips_text:"",
        quality: 0,
        stylize: 100,
        chaos: 100,
        upload_list: []
      }

      if (this.advanceForm) {
        parameters = this.advanceForm
      } else {
        let _form = this.getCache("formAdvanceParams") || ""
        if (_form) {
          parameters = JSON.parse(_form)
        }
      }
      let fg_tips = ""
      this.$store.state.hav_choose_tips.forEach(m => {
        fg_tips += " " + m.name
      })

      if(this.md5_key){
        this.$http.get(`https://payadmin.m.nengshuohuihua.com/wap/siteconfig/useexample/`,{
          params:{
            id:this.md5_id,
            md5_key:this.md5_key
          }
        }).then(res=>{
          // 同步请求
          this.submitQuestion({
            question: this.inputVal,
            parameters: parameters,
            img_model: this.img_model,
            is_fast: this.is_fast,
            fg_tips: fg_tips,
            iw_url: this.upload_img_url,
            iw: this.img_iw,
            pic_num: 1, // dall页面指定三图
          });
        })
      }else{
        // 同步请求
        this.submitQuestion({
          question: this.inputVal,
          parameters: parameters,
          img_model: this.img_model,
          is_fast: this.is_fast,
          fg_tips: fg_tips,
          iw_url: this.upload_img_url,
          iw: this.img_iw,
          pic_num: 1, // dall页面指定三图
        });
      }

    },
    submitQuestion(data, parent_msg_code, i) {

      if (this.sending) {
        this.$message({
          message: '正在任务，不要重复提交，请稍后！',
          type: 'waring'
        });
        return
      }
      this.sending = true;
      let date = new Date(this.currentTimer);
      let year = date.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
      * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
      * */
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      let time_add = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds
      let add = {
        add_time: time_add,
        img_index: 1,
        img_model: this.img_model,
        img_type: "img_c",
        img_url: "",
        is_fast: this.is_fast,
        is_public: 0,
        parameters: "",
        parent_img_type: "",
        progress: 0,
        prompt: this.inputVal,
        prompt_en: "",
        status: 1,
      }
      if (data.img_type != 'img_video') {
        this.draw_list.unshift(add);
        this.scrollToTop();
      }
      // this.draw_list.unshift(add);
      // this.scrollToTop();
      // this.inputVal = ''
      // 提交问题
      data.source = "pc";
      this.getPromptData3()

      this.$http.post('/front/aidl/draw/', data).then((res) => {
        // 获取用户信息
        this.getProfile()
        if (res.status == 200) {
          this.inputVal = "";
          this.md5_key = false
          this.md5_id = false
          // this.draw_list.splice(0,1,res.data.draw)
          // // this.draw_list.unshift(res.data.draw);
          // this.scrollToTop();
          // // 发送消息
          // this.checkIds.push(res.data.draw.draw_id)
          if (data.img_type != 'img_video') {
            this.draw_list.splice(0, 1, res.data.draw)
            this.scrollToTop();
            this.checkIds.push(res.data.draw.draw_id)
          } else {
            this.draw_list.unshift(...res.data.draw);
            this.scrollToTop();
            res.data.draw.forEach(mg_id => {
              this.checkIds.push(mg_id.draw_id)
            })
          }

          this.$message({
            message: '创建任务成功！',
            type: 'success'
          });

          this.fetchMsg();
        } else {


        }
      }).catch(res => {
        let message = res.message;
        this.draw_list.splice(0, 1)

        if (message == "vip_expire") {
          // VIP 过期了
          this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "no_open_vip") {
          // 未开通 VIP
          this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "no_gift_score") {
          // 积分不足
          this.$confirm('您的积分已经用完如需继续使用该功能请购买积分或升级套餐', '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "upgradevip") {
          // 队列已满

          this.$confirm(res.data.data.msg, '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "no_face_verify") {
          // 实名认证
          this.$refs.faceVerifyPopup.show()
          return
        }
        if (message.indexOf("您提问的内容包含违禁词") > -1) {
          message = "内容可能违反国家政策，请重新输入";
        }
        this.$confirm(message, '提示', {
          type: 'warning'
        }).then(() => {
        })
      }).finally(() => {
        this.sending = false;
      })
    },
    fetchMsg() {
      if (this.checkIds.length == 0) {
        return
      }
      if (this.timer) {
        clearInterval(this.timer);
      }

      this.timer = setInterval(() => {
        this.$http.post('/front/aimj/draw/check/', {ids: this.checkIds}).then((res) => {
          if (res.status == 200) {
            let item_list = res.data.item_list;
            let draw_id = 0;
            item_list.forEach(e => {
              draw_id = e.draw_id
              let item = this.draw_list.filter((obj) => obj.draw_id == draw_id)[0];

              item.status = e.status
              item.progress = e.progress;
              item.s_w = e.s_w
              item.s_h = e.s_h
              item.pic_num = e.pic_num
              item.prompt = e.prompt
              item.prompt_en = e.prompt_en
              item.retry_num = e.retry_num
              item.is_retry = e.is_retry
              item.regenerateload = false
              // item.img_url = e.img_url;
              item.iw_small_url = e.iw_small_url
              item.iw_url = e.iw_url
              item.model_version = e.model_version
              if (e.status > 2) {
                // 删除生成成功或失败的
                item.show_error = e.show_error
                if (e.show_error) {
                  this.$message.error(e.show_error)
                }
                this.checkIds = this.checkIds.filter(i => i !== draw_id)
              }
              if (e.status == 2 && e.local_img_url != "") {
                // 生成成功 并下载本地
                this.checkIds = this.checkIds.filter(i => i !== draw_id)
                item.img_url = e.local_img_url
                item.raw_img_url = e.raw_img_url
                this.scrollToTop();
                // 创作成功检测是否弹出挽留弹窗
                utils.checkContinuePop(this.$store.state.userInfo)
              }
              if (e.status == 3) {
                // 绘画失败
              }
            })
          }
          if (this.checkIds.length == 0) {
            clearInterval(this.timer);
          }
        }).catch((res) => {
          clearInterval(this.timer);
        })
      }, 3000)
    },

    imgRedraw(item) {
      // 重新绘画
      if (item.status != 2) {
        this.$message({
          message: '任务还未完成，不能操作！',
          type: 'waring'
        });
        return
      }
      let data = {
        parent_draw_id: item.draw_id,
        img_type: "img_redraw",
        img_index: 1
      }
      this.submitQuestion(data, [], 1);
    },
    drawImgUV(type, i, item, status) {
      // 对图片进行 U V 操作
      if (item.status != 2) {
        this.$message({
          message: '任务还未完成，不能操作！',
          type: 'waring'
        });
        return
      }
      if (status != 0) return
      item[type + '_code'][i] = 2;
      let data = {
        parent_draw_id: item.draw_id,
        img_type: "img_" + type,
        img_index: i + 1
      }
      this.submitQuestion(data, item[type + '_code'], i);
    },
    drawImgZoom(type, item) {
      // 对图片进行 zoom 操作
      if (item.status != 2) {
        this.$message({
          message: '任务还未完成，不能操作！',
          type: 'waring'
        });
        return
      }
      let data = {
        parent_draw_id: item.draw_id,
        img_type: "img_" + type,
        img_index: 1
      }
      this.submitQuestion(data, [], 0);
    },

    popClose() {
      this.$refs.viewPopup.close();
    },
    scrollToTop() {
      this.$nextTick(() => {
        let scrollWrap = this.$refs.scrollWrap;
        scrollWrap.scrollTop = 0;
      })
    },
    delete_draw_list(id, index) {
      // 删除
      this.$confirm('确定删除该创作记录吗，删除后不可恢复？', '提示', {
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/front/aimj/draw/${id}/`).then((res) => {
          this.draw_list.splice(index, 1)
        })
      })

    },
    showDefeatPopup(num) {
      num === 1 ? this.$refs.defeatPopup.show() : this.$refs.interpose.show()
    },
    defeatPopClose(num) {
      num === 1 ? this.$refs.defeatPopup.close() : this.$refs.interpose.close()
    },
    share_draw_item(item, index) {
      this.current_draw = item
      this.show_sharedraw_popup = true
    },
    recommendCallBack(draw_id) {
      // 推荐到广场 回调
      this.show_recommend_popup = false
      if (draw_id) {
        this.draw_list.forEach(e => {
          if (e.draw_id == draw_id) {
            e.is_public = 1
          }
        })
      }
    },
    pulic_draw_item(item, index) {
      // 点击弹出推荐到广场
      if (item.is_public == 0) {
        this.current_draw = item
        this.show_recommend_popup = true
      } else {
        item.is_public = 0
        this.$http.patch(`/front/aimj/user/draw/${item.draw_id}/`, {
          'action': 'public',
          data: {'sys_cate_id': 0}
        }).then((res) => {
          this.$message({
            message: '取消推荐成功',
            type: 'success'
          });
        }).finally((res) => {
          this.close()
        })
      }

    },
    fave_draw_item(draw, index) {
      // 采集
      this.$refs.drawCateEdit.show(draw, 1)
    },
    //点击弹出反馈弹窗
    handle_show_feedback_popup(item) {
      this.current_draw = item
      this.show_feedback_popup = true
    },
    async getJSON() {
      let url = 'https://mjimg.zhanjuzhe.cn/media/202407/19/1721384316144.png?width=700&height=700';
      try {
        let response = await fetch(url);
        return await response.json();
      } catch (error) {
      }
    },
    viewImg(item, type) {
      let img_url = item.raw_img_url
      this.split_img_url = img_url
      const canvas = this.$refs.localCanvas;
      let that = this
      var imgRaw = new Image();
      imgRaw.src = img_url
      imgRaw.setAttribute('crossOrigin', 'anonymous');
      imgRaw.onload = function () {
        var arr = []
        let canvasWidth = imgRaw.width / 2; // Assuming split in half
        let canvasHeight = imgRaw.height / 2; // Adjust as needed
        for (var i = 0; i <= 4; i++) {
          canvas.width = canvasWidth
          canvas.height = canvasHeight

          const ctx = canvas.getContext('2d');
          const x = i % 2 === 0 ? 0 : canvasWidth;
          const y = Math.floor(i / 2) === 0 ? 0 : canvasHeight;

          ctx.drawImage(imgRaw, x, y, canvasWidth, canvasHeight, 0, 0, canvasWidth, canvasHeight);

          const base64 = canvas.toDataURL('image/jpeg');
          arr.push(base64);
        }

        that.view_img_url = arr[type - 1]
        that.$refs.previewImg.clickHandler();
        that.$nextTick(() => {
          let wrapper = document.getElementsByClassName(
              "el-image-viewer__actions__inner"
          );
          if (wrapper.length > 0) {
            let downImg = document.createElement("i");
            downImg.setAttribute("class", "el-icon-download");
            wrapper[0].appendChild(downImg);
            downImg.addEventListener("click", () => {
              that.$message.success('已为您下载图片，如下载失败，请右键保存或长按保存图片');
              var a = document.createElement("a"); // 生成一个a元素
              var event = new MouseEvent("click"); // 创建一个单击事件
              a.download = Date.now(); // 设置图片名称
              a.href = that.view_img_url; // 将生成的URL设置为a.href属性
              a.dispatchEvent(event); // 触发a的单击事件
            });
          }
        })
      }
    },
    caiJiOk(item) {
      // 采集回调
      this.draw_list.forEach(e => {
        if (e.draw_id == item.draw_id) {
          e.cate_id = 8
        }
      })
    },

    clickImage(downId,position) {
      console.log('下载')
      // 下载图片
      this.$nextTick(() => {
        const wrapper = document.querySelector('.el-image-viewer__actions__inner');
        if (!wrapper) return;
        if (wrapper.querySelector('.my-download-btn')) return;

        const downBtn = document.createElement('i');
        downBtn.setAttribute('class', 'el-icon-download my-download-btn');
        // 绑定点击事件
        downBtn.addEventListener('click', async () => {
          if (!this.checkLogin()){

            return // 登录拦截
          }
          if (position=='sample'){
            this.$message.warning('当前样例不可下载，请生成后重试！')
            return // 样例拦截
          }
          this.$http.get(`/front/aimj/draw/down/${downId}/?${position!=undefined?'nano_position='+position:''}`).then(res => {
            // 假设你用的是 axios 封装，res.data 才是后端 JSON
            if(res.status==200){
              window.location.href = res.data.url
            }else{
              console.log('不是200')
              let message = res.message
              utils.createErrTip(message)
            }
          }).catch(err => {
            console.error('下载失败', err);
            let message = err.message;
            utils.createErrTip(message)
          });

        });
        wrapper.appendChild(downBtn);
      });
    },
    ImageJump(imgurl, s_w, s_h) {
      // window.open(imgurl, '_blank');
      window.open(imgurl, '_blank');
    },
    //下载
    down(item) {
      this.$http.get(`/front/aimj/draw/video/${item.draw_id}/?soft=1`,).then(res => {
        if (res.status == '200') {
          window.location.href = res.data.url
        }  else {
          let message = res.message
          utils.createErrTip(message)
        }
      }).catch(err=>{
        let message = err.message;
        utils.createErrTip(message)
      }).finally(() => {
        this.loading = false
      })

    },
    regenerate(item, ind) {
      this.draw_list[ind].regenerateload = true
      this.$forceUpdate()
      this.$http.post(`/front/aimj/draw/retry/`, {id: item.draw_id}).then(res => {
        if (res.status == '200') {
          this.draw_list[ind].is_retry = 1
          this.draw_list[ind].regenerateload = false
          this.scrollToTop();
          this.$message.success('重新生成创建成功');
          this.draw_list.unshift(res.data);
          this.checkIds.push(res.data.draw_id)
          this.fetchMsg();
        }
      }).catch(err => {
        this.draw_list[ind].regenerateload = false
        this.$forceUpdate()
        let message = err.message;
        if (message == "vip_expire") {
          // VIP 过期了
          this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "no_open_vip") {
          // 未开通 VIP
          this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "no_gift_score") {
          // 积分不足
          this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "upgradevip") {
          // 队列已满
          this.$confirm(err.data.data.msg, '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "no_face_verify") {
          // 实名认证
          this.$refs.faceVerifyPopup.show()
          return
        } else if (message == "retry_num_max") {
          this.$confirm('已超出最大重试次数', '提示', {
            type: 'warning'
          }).then(() => {
          })
          return;
        }
        if (message.indexOf("您提问的内容包含违禁词") > -1) {
          message = "内容可能违反国家政策，请重新输入";
        }
        this.$confirm(message, '提示', {
          type: 'warning'
        }).then(() => {
        })
      })
    },
    getPromptData2(data) {
      this.inputVal = data
      // this.perIncan = true
      // this.sendMsg()
    },
    getPromptData3() {
      // ai提示词重置
      this.perIncan = false
      this.$refs.promptBox.show(false)
    },
    getPromptData4() {
      // 关闭
      console.log('auto_spell', this.auto_spell)
      if (this.auto_spell == 0) {
        this.$confirm('关闭自动优化描述词，生成的绘画内容可能不佳，请谨慎关闭!', '提示', {
          confirmButtonText: '确定关闭',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.auto_spell = '0'
        }).catch(() => {
          this.auto_spell = '1'

        });
      }
    },
    achievetask(res){
      console.log('编辑成功同步列表')
      console.log(res)
      this.draw_list.unshift(res.draw);
      this.scrollToTop();
      this.checkIds.push(res.draw.draw_id)
      this.$message({
        message: '创建任务成功！',
        type: 'success'
      });
      this.fetchMsg();
    },

  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.mgTitp {
  display: inline-block;
  padding: 0 7px;
  background: linear-gradient(to right, rgb(99, 231, 82), rgb(98, 238, 247));
  border-radius: 4px;
  font-size: 12px;
  line-height: 24px;
  color: #000;
  margin-right: 10px;
}

@keyframes scale-breathe {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.05);
  }
  75% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}

.btm_area_con {
  position: absolute;
  left: 15px;
  right: 15px;
  bottom: 25px;
  border: 2px solid #5865f2;
  border-radius: 8px;
  background-color: #37393f;
  padding: 10px 15px;

  .begin_draw_tips {
    position: absolute;
    top: -60px;
    left: 10%;
    animation: scale-breathe 2s infinite linear;
  }

  .text_area {
    position: relative;

    .text_1area {
      display: flex;
      align-items: center;
    }

    .textarea {
      width: 100%;
      flex: 1;
      height: 42px;
      line-height: 21px;
      font-size: 14px;
      color: #fff;
      border: none;
      background: transparent;
      margin-bottom: 10px;
    }

    .submit {
      width: 80px;
      background: #5865f2;
      border-radius: 6px;
      padding: 7px 14px;
      cursor: pointer;

      /deep/ .el-loading-mask {
        background: none;
      }

      img {
        width: 14px;
        height: 14px;
      }

      span {
        font-size: 14px;
        color: #fff;
        margin-right: 5px;
      }

      &:hover {
        background-color: rgba(88, 101, 242, 0.867);
      }
    }
  }

  .query_area {
    font-size: 14px;
    color: #b4b9bf;
    display: flex;
    justify-content: space-between;

    i {
      font-size: 15px;
      margin-right: 2px;
    }

    .query_area_item {
      cursor: pointer;


      .query_select {
        width: 89px;
        font-size: 12px;

        /deep/ .el-input__inner {
          border: 0;
          font-size: 12px;

          height: 28px;
          line-height: 28px;
          color: #6d6f78;
          background: #17181a url("./img/icon_img34.png") no-repeat 10px center;
          background-size: 14px 14px;
          padding-left: 30px;
        }

        /deep/ .el-input__suffix {
          display: none;
        }
      }

      &:hover {
        color: #ffffff;

      }
    }

    .query_area_btn {
      margin-left: 10px;
      margin-right: 10px;
      cursor: pointer;


      &:hover {
        color: #ffffff;
      }


    }

    .automatic {
              display: flex;
              align-items: center;
              cursor: pointer;
              background: linear-gradient(to right, #fd7a57, #fe3f40);
              border-radius: 4px;
              padding: 3px 2px 5px 20px;
              font-size: 12px;
              user-select: none;
              color: #fff;
              position: relative;
              opacity: 0.5;
              .ai_tishi_img{
                width: 12px;
                height: 12px;
                position: absolute;
                left: 5px;
                top: 50%;
                transform: translateY(-50%);
                // margin-right: 4px;
              }
    }

    .spell {
      font-size: 13px;
      // margin-left: 7px;
    }
  }

  .mode_hover {
    position: absolute;
    bottom: 53px;
    left: 5px;
    background-color: #17181a;
    padding: 5px 0;
    border-radius: 6px;

    &:before {
      position: absolute;
      content: " ";
      left: 50%;
      bottom: -8px;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-right: 8px solid transparent;
      border-left: 8px solid transparent;
      border-top: 8px solid #17181a;
    }

    .mode_hover_item {
      padding: 10px 16px;
      cursor: pointer;

      span {
        font-size: 13px;
        color: #b5bac1;
      }

      img {
        width: 14px;
        height: 14px;
        margin-left: 10px;
      }

      &:hover {
        background-color: #2a2a2a;
        color: #fff;
      }
    }
  }

  .search_tips {
    background-color: #1e1f22;
    position: absolute;
    width: 100%;
    top: -10px;
    left: 0;
    transform: translateY(-100%);
    border-radius: 6px;
    padding: 15px 15px 25px 15px;
    color: #b5bac1;

    .title {
      padding-bottom: 6px;

      p {
        font-size: 16px;

        img {
          width: 20px;
          height: 20px;
          margin-right: 10px;
        }

        span {
          font-size: 20px;
          font-weight: bold;
          color: #f90;
        }
      }

      .close {
        width: 20px;
        height: 20px;
        cursor: pointer;
        opacity: 0.4;

        &:hover {
          opacity: 1;
        }
      }
    }

    .tips_list {
      height: 500px;
      overflow-y: auto;

      .tips_list_item {
        padding: 12px 6px;
        border-radius: 3px;
        cursor: pointer;

        .tips_list_item_avatar {
          width: 35px;
          height: 35px;
          margin-right: 15px;
          border-radius: 100%;
        }

        .text {
          flex: 1;

          p {
            font-size: 14px;
            color: #b5bac1;
            line-height: 1;
          }

          .zh {
            margin-bottom: 7px;
          }
        }

        &:hover {
          background-color: #2b2d31;
        }
      }
    }
  }
}

.screen {
  color: #666;
  text-align: center;
  //margin: 10px 0;
  font-size: 12px;
  position: absolute;
  left: 15px;
  right: 15px;
  bottom: 4px;
}


.mj_page {
  width: 100%;
  height: 100%;
  background: #2b2d31;
  border-radius: 10px;
}

.left_area {
  flex-direction: column;
  height: 100%;

  .logo_area {
    flex-direction: column;
    width: 216px;
    height: 216px;
    background: #1e1f22;
    border-radius: 10px;
    margin: 12px;

    img {
      width: 64px;
      height: 64px;
      border-radius: 100%;
    }

    .title {
      font-size: 14px;
      color: #c8c9ca;
      margin: 10px 0;

      span {
        padding: 2px 8px;
        border-radius: 3px;
        background: #23a559;
        margin-left: 5px;
        font-size: 12px;
        color: #fff;
      }
    }

    .desc {
      font-size: 12px;
      color: #7d8289;
      padding: 0 10px;
      text-align: center;
    }
  }

  .model_list {
    font-size: 13px;
    font-weight: bold;
    color: #949ba4;
    padding: 0 8px;
    flex: 1 1 0%;

    .title {

      img {
        margin-right: 5px;
      }
    }

    .item {
      margin-top: 10px;
      padding: 8px 12px;
      border-radius: 2px;
      cursor: pointer;
      position: relative;

      span {
        color: #949ba4;
        margin-right: 10px;
        font-size: 14px;
      }

      .desc {
        strong {
          font-size: 13px;
          color: #fff;
          line-height: 1;

          img {
            width: 36px;
            height: 12px;
            margin-left: 5px;
          }
        }

        p {
          font-size: 12px;
          color: #949ba4;
          word-break: break-all;
          white-space: normal;
          margin-top: 3px;
        }
      }

      &:hover,
      &.active {
        background: linear-gradient(to right, #305543 0%, #3d437e 100%);
      }

      &.active {
        &:after {
          content: "";
          position: absolute;
          width: 14px;
          height: 10px;
          background: url("./img/icon_img5.png") no-repeat center;
          background-size: cover;
          right: 10px;
          top: calc(50% - 5px);
        }
      }
    }
  }

  .person {
    padding: 8px 16px;
    background: #232428;
    position: relative;

    .avatar {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 7px;
      cursor: pointer;
    }

    .info {
      width: 150px;
      cursor: pointer;

      .name {
        font-size: 13px;
        color: #fff;
        margin-bottom: 5px;

        img {
          width: 20px;
          height: 20px;
          // filter: grayscale(100%);
        }
      }

      .id {
        font-size: 12px;
        color: #b5bac1;
      }
    }

    .icon_person {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }

    .person_hover {
      background: #111214;
      border-radius: 8px;
      padding: 18px 16px;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 100%;
      width: 308px;
      z-index: 99;
      animation: fade-in 0.3s ease-in forwards;

      .user_avatar {
        position: relative;
        z-index: 2;
        padding: 20px 10px 0;

        &:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          width: 100%;
          height: 60px;
          background: #5865f2;
          z-index: -1;
          border-radius: 6px 6px 0 0;
        }

        .pic {
          width: 80px;
          height: 80px;
        }

        .edit_area {
          display: block;
          width: 20px;
          height: 20px;
          padding: 4px;
          border-radius: 100%;
          background-color: rgba(0, 0, 0, 0.24);
          cursor: pointer;

          img {
            width: 12px;
            height: 12px;
          }
        }
      }

      .item {
        padding: 14px 0;
        margin: 0 20px;
        border-bottom: 1px solid #2e2f34;
        color: #b4b9bf;
      }

      .user {
        .name {
          font-size: 16px;
          color: #fff;
          margin-bottom: 5px;

          img {
            width: 20px;
            height: 20px;
            // filter: grayscale(100%);
          }
        }

        .id {
          font-size: 12px;
          color: #b5bac1;
        }
      }

      .open {
        .open_desc {
          color: #000;
          color: #68d1bf;
          margin-top: 5px;
        }
      }

      .point {
        .flex {
          margin-top: 5px;
          color: #68d1bf;
          font-weight: bold;
        }

        img {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }
      }

      .logout {
        border-bottom: none;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;

        .logout_desc {
          img {
            width: 18px;
            height: 18px;
            margin-right: 10px;
          }
        }

        .icon_right {
          width: 7px;
          height: 10px;
        }
      }

      .close_btn2 {
        position: relative;

        div {
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #111214;
          position: absolute;
          top: -25px;
          right: -25px;
          font-size: 20px;
          border-radius: 10px;

          i {
            width: 100%;
            height: 100%;
          }
        }

      }
    }
  }
}

.draw_area {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #313338;

  .draw_area_tips {
    height: 48px;
    padding: 0 16px;
    border-bottom: 1px solid #26282c;
    display: flex;
    align-items: center;

    .one {
      font-size: 18px;
      color: #949ba4;
    }

    .two {
      font-size: 16px;
      color: #fff;
      margin: 0 10px;
    }

    .three {
      font-size: 12px;
      color: #f0b132;
    }
  }

  .draw_scroll {
    padding-top: 10px;
    padding-bottom: 70px;
    flex: 1;
    position: relative;
    z-index: 9;
    overflow-y: auto;

    .draw_list {
      padding-right: 12px;
      position: relative;
      z-index: 2;

      .draw_list_item {
        padding: 16px;
        background: rgba(152, 121, 69, 0.13);
        border-left: 2px solid #f0b132;
        border-radius: 2px;
        margin-bottom: 15px;

        .avatar {
          width: 48px;
          height: 48px;
          border-radius: 100%;
          margin-right: 20px;
        }

        .text {
          flex: 1;

          .title {
            .info {
              .name {
                font-size: 16px;
                color: #fff;
              }

              .tag {
                line-height: 24px;
                background-color: #23a559;
                color: #fff;
                font-size: 12px;
                padding: 0 7px;
                border-radius: 4px;
                margin: 0 10px;
              }

              .time {
                color: #707070;
              }
            }

            .delete {
              cursor: pointer;
              margin-left: 8px;

              img {
                width: 20px;
                height: 20px;
                opacity: 0.5;
                margin-right: 3px;

                &.share {
                  width: 16px;
                  height: 16px;
                }
              }

              &:hover {
                color: #fff;

                img {
                  opacity: 1;
                }
              }
            }
          }

          .desc {
            margin: 10px 0;

            p {
              font-size: 14px;
              color: #fff;
              //display: -webkit-box;
              -webkit-box-orient: vertical;
              overflow: hidden;
              -webkit-line-clamp: 3;
              padding: 10px 0;
              word-break: break-all;
            }

            .en {
              color: #999168;
              border-top: 1px solid #555041;
            }
          }
        }

        .big_img {
          position: relative;

          img {
            max-height: 400px;
          }

          .tozan {
            -webkit-user-select: none;
            /* Safari */
            -moz-user-select: none;
            /* Firefox */
            -ms-user-select: none;
            /* IE10+/Edge */
            user-select: none;
            display: flex;
            flex-direction: column;
            align-items: end;
            position: absolute;
            right: 20px;
            top: 10px;

            .zanOne {
              width: 90px;
              height: 30px;
              display: inline-flex;
              line-height: 30px;
              background-color: #ffffff;
              /* 背景颜色 */
              color: #000;
              /* 文字颜色 */
              border: none;
              border-radius: 3px;
              /* 圆角 */
              font-size: 14px;
              cursor: pointer;
              box-shadow: 0 0 8px rgba(255, 255, 255, .1), 0 0 10px rgba(255, 255, 255, .2), 0 0 10px rgba(255, 255, 255, .5);

              /* 荧光效果 */
              .zanImg {
                width: 18px;
                height: 18px;
                margin: 0 10px;
                font-size: 0;
                margin-top: 5px;
              }
            }

            .zanTex {
              font-size: 14px;
              color: #99916b;
              margin: 15px 0;
            }

            .zanTwo {
              color: #f0b53e;
              /* 文字颜色 */
              box-shadow: 0 0 8px rgba(241, 170, 38, 0.1), 0 0 10px rgba(248, 163, 53, 0.2), 0 0 10px rgba(255, 255, 255, .5);
              /* 荧光效果 */
              cursor: auto;
            }
          }
        }

        .options {
          .options_list {
            margin-top: 10px;

            p {
              font-size: 14px;
              color: #fff;
            }

            .tips_icon {
              width: 18px;
              height: 18px;
              opacity: 0.5;
            }

            span {
              font-size: 13px;
              width: 58px;
              height: 32px;
              display: flex;
              justify-content: center;
              align-items: center;
              color: #fff;
              background: #4e5058;
              margin-left: 8px;
              border-radius: 3px;
              cursor: pointer;

              img {
                width: 18px;
                height: 18px;
              }

              &:hover {
                background: #6e717c;
              }

              &.span {
                width: 100px;

                img {
                  margin-right: 5px;
                }
              }

              &.span2 {
                width: 40px;
              }
            }

            //
            .redraw {
              img {
                height: 20px;
                // margin-top: 5px;
              }

              line-height: 32px;
            }

            .btn {
              // flex-grow: 1;
              // height: 32px;
              // line-height: 32px;
              // color: #18a058;
              // background-color: #dbefe4;
              // border-radius: 2px;
              // font-size: 12px;
              // font-weight: bold;
              // text-align: center;
              // cursor: pointer;
              // width: 0;
              &:not(:last-child) {
                margin-right: 0px;
              }

              &.loading {
                opacity: 0.6;

                svg {
                  margin-top: -4px;
                  vertical-align: middle;
                  margin-right: 4px;
                  animation: rotate 2s linear infinite;
                }
              }

              &.redraw2 {
                background-color: #f5f6fb;

                img {
                  height: 30px;
                }
              }

              &.disabled {
                cursor: not-allowed;
                background-color: #ddd;
                color: #666;
              }
            }

            //
          }
        }
      }
    }
  }

  .btm_area {
    padding: 0 16px;
    height: 85px;
    border-top: 1px solid #26282c;
    position: relative;
    z-index: 19;
  }
}

.fz13 {
  font-size: 13px;
}

.c-fff {
  color: #fff;
}

.userinfo_popup {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1501;
  bottom: 0;
  left: 0;
  transition: all 0.3s;
  background: rgba(0, 0, 0, 0.8);
  overflow: auto;
  animation: fadeInSlowAni 0.3s 1;
}

.centerPanel {
  position: fixed;
  z-index: 1501;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: transform 0.2s;
}

.con {
  width: 410px;
  height: 560px;
  padding: 20px;
  background-color: #1e1f22;
  border: 2px solid #5865f2;
  border-radius: 6px;

  .full {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;

    .alert_title {
      p {
        font-size: 14px;
        color: #fff;
      }

      .close {
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }

    .avatar {
      flex-direction: column;
      cursor: pointer;

      .pic {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        margin-bottom: 5px;
        margin-top: 5px;
      }

      .text {
        font-size: 14px;
        color: #fff;

        img {
          width: 14px;
          height: 14px;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }

    .info_list {
      padding: 15px 18px;

      .info_list_title {
        font-size: 14px;
        color: #fff;
        margin-left: -16px;
      }

      .info_item {
        padding: 15px 0;
        border-bottom: 1px solid #36373d;

        .title {
          img {
            width: 16px;
            height: 16px;
            margin-right: 8px;
          }

          p {
            font-size: 14px;
            color: #b0b0b0;
          }
        }

        .text {
          font-size: 14px;
          color: #b0b0b0;

          .btn {
            padding: 0 14px;
            display: block;
            line-height: 34px;
            cursor: pointer;
            background-color: #5865f2;
            color: #fff;
            border-radius: 4px;

            &:hover {
              background-color: rgba(88, 101, 242, 0.867);
            }
          }
        }
      }
    }
  }
}

.userphone_con {
  width: 440px;
  padding: 20px;
  background-color: #1e1f22;
  border: 2px solid #5865f2;
  border-radius: 6px;

  .full {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;

    .alert_title {
      justify-content: end;

      .close {
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }

    .desc {
      text-align: center;
      font-size: 14px;

      .c-fff {
        font-size: 16px;
        margin-bottom: 10px;
      }
    }

    .form {
      padding: 0 30px 50px;

      .input {
        border: 2px solid #36373d;
        background: #2b2d31;
        padding: 9px 12px;
        border-radius: 8px;
        margin-top: 25px;

        input {
          height: 30px;
          line-height: 30px;
          flex: 1;
          border: 0;
          background: transparent;
          color: #fff;
          font-size: 14px;
        }

        span {
          cursor: pointer;
          margin-left: 20px;
          color: #5865f2;

          &:hover {
            color: #5865f2cc;
          }
        }
      }
    }

    .submit {
      margin: 0 30px 50px;
      cursor: pointer;
      background-color: #5865f2;
      color: #fff;
      border-radius: 6px;
      line-height: 53px;
      text-align: center;
      font-size: 16px;

      &:hover {
        background-color: rgba(88, 101, 242, 0.867);
      }
    }
  }
}

.tooltips_text {
  font-size: 14px;
  line-height: 1.7;
}

.create_error {
  width: 190px;
  //height: 190px;
  background-color: #fff;
  border-radius: 4px;
  padding: 14px 10px;
  text-align: center;
  font-size: 14px;
  margin-top: 20px;

  .error_icon {
    display: block;
    width: 35px;
    margin: 0 auto;
  }

  .error_text {
    color: #ccc;
    //line-height: 64px;
    margin: 10px 0 36px;
  }

  .error_text2, .error_text3 {
    font-size: 12px;
    color: #56b15b;
  }

  .error_text2 {
    cursor: pointer;
    margin-bottom: 5px;
  }

  .error_text3 {
    color: #ccc;
    margin-bottom: 36px;
  }

  .error_text4 {
    font-size: 12px;
    color: #ccc;
    line-height: 1.8;

    a {
      color: red;
    }
  }

  .error_btn {
    display: inline-block;
    cursor: pointer;
    color: #ffab46;
    padding-top: 15px;
  }
}

.create_error_old {
  width: 190px;
  // height: 190px;
  background-color: #fff;
  border-radius: 4px;
  padding-top: 28px;
  text-align: center;
  font-size: 14px;
  margin-top: 20px;

  .error_icon {
    display: block;
    width: 35px;
    margin: 0 auto;
  }

  .error_text {
    color: #ccc;
    //line-height: 64px;
    margin: 10px 0 0px;
  }

  .error_btn {
    display: inline-block;
    cursor: pointer;
    color: #ffab46;
    padding: 30px 0;
  }
}

.defeat_popup {
  width: 600px;
  padding: 0 30px 36px;
  background-color: #fff;
  border-radius: 10px;

  .popup_title {
    font-size: 16px;
    font-weight: bold;
    line-height: 76px;
    text-align: center;
  }

  .popup_content {
    padding-bottom: 10px;

    .content_item {
      padding-bottom: 18px;
      font-size: 13px;
      line-height: 25px;

      .item_answer {
        color: #999;
      }
    }
  }

  .close_btn {
    width: 240px;
    height: 50px;
    border: none;
    border-radius: 5px;
    background-color: #5865f2;
    color: #fff;
    font-size: 15px;
    display: block;
    margin: 0 auto;
  }
}

.msg-item-content {
  font-size: 13px;
  line-height: 20px;
  padding-top: 5px;

  &.detail_loading {
    .remove_icon {
      // display: none;
      position: absolute;
      top: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("./img/update_close.png");
      background-color: rgba(100, 100, 100, 0.6);
      cursor: pointer;
      border-radius: 3px;
    }

    .loading_text {
      padding-left: 12px;
      color: #f0b132;
    }
  }
}

.creating_progress {
  margin-top: 15px;
  display: flex;
  align-items: center;
  width: 360px;

  .progress_bar {
    flex-grow: 1;
    height: 10px;
    border-radius: 5px;
    background-color: #dbefe4;
    margin-right: 6px;

    .progress_line {
      height: 100%;
      background-color: #f0b132;
      border-radius: 5px;
      transition: width 0.3s linear;
    }
  }

  .progress_percent {
    font-size: 12px;
    line-height: 1;
    color: #f0b132;
    white-space: nowrap;
  }
}

.msg_img_wrap {
  position: relative;
  display: inline-block;

  // border-radius:5px;
  .look_img {
    display: none;
    //opacity: 0;
    cursor: pointer;
    width: 100px;
    height: 36px;
    position: absolute;
    top: 10px;
    right: 10px;
    border: rgba(88, 101, 242, 0.8) solid 2px;
    background-color: rgba(88, 101, 242, 0.533);
    border-radius: 6px;
    color: white;
    font-size: 14px;
    box-sizing: border-box;
    line-height: 32px;
    text-align: center;
  }

  &:hover {
    .img_footer {
      bottom: 0;
    }
  }


  .img_footer {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: -40px;
    height: 40px;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: space-around;
    transition: bottom 0.3s;

    .footer_item {
      cursor: pointer;

      .footer_icon {
        display: inline-block;
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-right: 5px;
        background-size: 100% 100%;

        &.download {
          background-image: url("./img/download.png");
        }

        &.preview {
          background-image: url("./img/preview_img.png");
        }

        &.delete {
          background-image: url("./img/remove.png");
        }
      }

      span {
        vertical-align: middle;
        display: inline-block;
        font-size: 14px;
        color: #fff;
      }
    }
  }

  .SeniorEditor {
    display: flex;

    .SeniorBox1 {
      position: relative;
      margin-right: 10px;

      .artwork {
        position: absolute;
        top: 5px;
        right: 5px;
        background: #383838;
        padding: 5px 8px;
        color: #fff;
        border-radius: 4px;
      }


    }

    .SeniorBox2 {
      position: relative;

      .outcome {
        position: absolute;
        top: 5px;
        left: 5px;
        background: #383838;
        padding: 5px 8px;
        color: #a2f717;
        border-radius: 4px;
      }

    }
  }


}

.interpose {
  width: 320px;
  //height: 280px;
  background-color: #000000;
  border: 2px solid #5865f2;
  border-radius: 5px;
  padding: 20px 10px;
  color: #fff;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .close {
      width: 28px;
      height: 28px;
      border-radius: 3px;
      cursor: pointer;
      background-color: black;
      display: flex;
      justify-content: center;
      align-items: center;

      div {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        cursor: pointer;
        background-color: #707072;
        position: relative;
      }

      div::before,
      div::after {
        content: "";
        position: absolute;
        height: 10px;
        width: 2px;
        background-color: black;
        border-radius: 1px;
      }

      div::before {
        transform: rotate(45deg);
        top: 3px;
        right: 7px; /* 调整这些值以使图像在容器中居中 */
      }

      div::after {
        transform: rotate(-45deg);
        top: 3px;
        right: 7px; /* 调整这些值以使图像在容器中居中 */
      }
    }

    .close:hover {
      background-color: #343538;

      div::before,
      div::after {

        background-color: #343538;

      }

    }


  }

  .body {
    width: 100%;
    height: 170px;
    background-color: #2b2d31;
    border-radius: 3px;
    margin: 10px 0;
    padding: 10px 10px;
    position: relative;

    .text {
      width: 100%;
      height: 150px;
      background-color: #2b2d31;
      border: none;
      color: #c8c9ca;
    }

    .text_num {
      position: absolute;
      right: 10px;
      bottom: 5px;
      font-size: 12px;
      color: #909399;
    }
  }

  .bottom {
    width: 240px;
    height: 40px;
    background-color: #5865f2;
    border-radius: 20px;
    text-align: center;
    line-height: 40px;
    margin: 0 auto;
    cursor: pointer;
  }

  .bottom:hover {
    background-color: #4c58d2;
  }
}

.msg_img_wrap:hover {
  .look_img {
    display: block;
  }
}

.mg_video_box {
  // height: 400px;
  .mg_video_item {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;
    // .videoBox::-webkit-media-controls {
    //   display: none !important;
    // }
    // .videoBox::-moz-media-controls {
    //   display: none !important;
    // }
    // .videoBox::-ms-media-controls {
    //   display: none !important;
    // }
    // .videoBox::-o-media-controls {
    //   display: none !important;
    // }
    .play-btn {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: rgba(19, 18, 18, 0.6);
      color: white;
      font-size: 24px;
      border: none;
      border-radius: 50%;
      // padding: 12px 20px;
      cursor: pointer;
      z-index: 10;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    video {
      max-width: 100%; /* 限制宽度不超过容器宽度 */
      max-height: 100%; /* 限制高度不超过容器高度 */
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* 可选，阴影效果 */
      border-radius: 8px; /* 可选，圆角效果 */
    }
  }
}
</style>